module.exports = __webpack_public_path__ + "img/learningful-glyphs_a6f0f447f971e8c2fd516dd40385e89b.48d388e.svg";